import type { Reroute } from '@sveltejs/kit';
import { deLocalizeUrl } from '$lib/paraglide/runtime';

// Le reroute hook tourne avant le routing SvelteKit : il enleve le prefixe de locale
// (/fr/office -> /office) pour que SvelteKit puisse resoudre le bon dossier sous src/routes/.
// Le runtime Paraglide retient la locale extraite et la rend disponible via getLocale().
export const reroute: Reroute = (request) => {
  return deLocalizeUrl(request.url).pathname;
};
